import { render, staticRenderFns } from "./DashboardLayoutClient.vue?vue&type=template&id=4618f3fc&"
import script from "./DashboardLayoutClient.vue?vue&type=script&lang=js&"
export * from "./DashboardLayoutClient.vue?vue&type=script&lang=js&"
import style0 from "./DashboardLayoutClient.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports